<template>
    <v-data-table :headers="headers" :items="dependencies" disable-pagination hide-default-footer sort-by="titel" dense>
        <template #item.type="{ item, size }">
            <TypIcon :address-record="item" :size="size" />
            <LegalTypeIcon :address-record="item" :size="size" />
        </template>
        <template #item.link="{ item }">
            <a :href="urlForDependency(item)" target="_blank" :title="$t('open_in_new_tab')">
                <KpIcon icon-cls="link" color="primary" />
            </a>
        </template>
        <template #item.title="{ item }">
            {{ displayTitle(item) }}
        </template>
    </v-data-table>
</template>

<script setup>
import { computed } from 'vue';
import { getI18nInstance as i18n } from '@/i18n';
import LegalTypeIcon from '../address/LegalTypeIcon.vue';
import TypIcon from '../address/TypIcon.vue';
import { useRouter, useRoute } from 'vue-router/composables';

defineProps({
    dependencies: {
        type: Array,
        required: true,
    },
});

const route = useRoute();
const router = useRouter();

const headers = computed(() => {
    return [
        { text: i18n().t('typ'), sortable: true, value: 'type', width: 100 },
        { text: i18n().t('titel'), sortable: true, value: 'title' },
        { text: i18n().t('status'), sortable: true, value: 'status', width: 100 },
        { value: 'link', sortable: false, width: 50 },
    ];
});

function displayTitle(item) {
    if (item.title) {
        return item.title;
    }
    if (item.first_name || item.surname) {
        return `${item.first_name} ${item.surname}`;
    }
    return '- kein Titel -';
}

function urlForDependency(record) {
    const name = 'address-edit';
    const id = record['id'];
    return new URL(
        router.resolve({
            name,
            params: { id, backRoute: { route } },
        }).href,
        window.location.origin,
    ).href;
}
</script>

<style lang="scss" scoped></style>
